import React from 'react';
import { IoClose } from 'react-icons/io5';
import { FiBook, FiVideo, FiCommand, FiHelpCircle, FiMail, FiInfo } from 'react-icons/fi';
import { IconType } from 'react-icons';
import { useTranslation } from 'react-i18next';

interface HelpMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const HelpMenu: React.FC<HelpMenuProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('dashboard');

  if (!isOpen) return null;

  const handleItemClick = (action: string) => {
    // Placeholder pour les actions futures
    console.log(`Help action: ${action}`);
    onClose();
  };

  const menuItems: Array<{ icon: IconType; labelKey: string; action: string }> = [
    { icon: FiBook, labelKey: 'helpMenu.documentation', action: 'documentation' },
    { icon: FiCommand, labelKey: 'helpMenu.shortcuts', action: 'shortcuts' },
    { icon: FiVideo, labelKey: 'helpMenu.tutorials', action: 'tutorials' },
    { icon: FiHelpCircle, labelKey: 'helpMenu.gettingStarted', action: 'getting-started' },
    { icon: FiMail, labelKey: 'helpMenu.support', action: 'support' },
    { icon: FiInfo, labelKey: 'helpMenu.about', action: 'about' }
  ];

  return (
    <div className="absolute top-full right-0 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50 p-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-lg font-semibold text-gray-900">{t('helpMenu.title')}</span>
        <button onClick={onClose} className="text-gray-500 hover:text-red-500 text-xl">
          <IoClose />
        </button>
      </div>

      <ul className="text-sm text-gray-700 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <li
              key={item.action}
              onClick={() => handleItemClick(item.action)}
              className="flex items-center cursor-pointer hover:text-blue-600 hover:bg-gray-50 p-2 rounded-lg transition"
            >
              <Icon className="mr-3 text-base" /> {t(item.labelKey)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HelpMenu;
